import * as React from "react";
function SvgIcShare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.741 14.855a2.282 2.282 0 013.14 1.17 2.292 2.292 0 11-4.408.877c.003-.238.044-.474.12-.7L8.38 12.615a2.292 2.292 0 11.003-1.886l6.253-3.61a2.275 2.275 0 11.39.642L8.57 11.486c.002.024.006.047.009.07.005.037.01.074.01.113 0 .04-.005.078-.01.117l-.01.072 6.368 3.676c.211-.286.487-.518.804-.679zm1.884-9.853a1.542 1.542 0 10-1.713 2.564 1.542 1.542 0 001.713-2.564zM6.3 13.208a1.541 1.541 0 110-3.083 1.541 1.541 0 010 3.083zm9.605 4.976a1.542 1.542 0 101.713-2.564 1.542 1.542 0 00-1.713 2.564z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcShare;
